<template>
    <div>
    	<header class="mui-bar mui-bar-nav">
			<a class="mui-icon mui-icon-left-nav mui-pull-left" @click="$router.push({path: '/home'});"></a>
			<h1 class="mui-title">选择区域</h1>
			<button class="mui-btn mui-btn-link mui-pull-right" @click="selectFacade()">确定</button>
		</header>
		<div class="mui-content">
			<!--<div class="nowSite">
				<span>【站点id站点id】站点名称站点名称</span>
				<button class="mui-btn mui-btn-link mui-pull-right"><a @click="goSiteList">更换站点</a></button>
			</div>-->
			<p class="title">选择区域</p>
			<ul class="mui-table-view mui-table-view-radio" v-if="myFacades.length>0">
				 <li class="mui-table-view-cell myFacade" v-for="(myFacade,index) in myFacades" :key="index" :class="{'mui-selected':(myFacade.active)}" @click="changeSel(myFacade)">
				 	<a class="mui-navigate-right">
						[{{myFacade.facade_code}}]{{myFacade.facade_name}}
					</a>
				 </li>
			</ul>
			<div class="norecord" v-else>
				<img src="../assets/imgs/noInfo.png" class="noInfo"/>
				<p>暂无数据</p>
			</div>
		</div>	
    </div>
</template>
<script>
	import { GetFacadeList } from '@/request/api';
    export default{
        data() {
            return {
            	nowSelect:'',
            	myFacades: []
            };
        },
        mounted() {
        	var fadeInfo = sessionStorage.getItem("facade");
        	if(fadeInfo){
        		this.nowSelect = JSON.parse(fadeInfo).id;
        	}
			var tenant_id = sessionStorage.getItem("tenant_id");
			var _this = this;
            GetFacadeList({     
		    	"tenant_id": tenant_id,     
		   	}).then(res => {
		    	// 获取数据成功后的其他操作
		    	if(res.result =='true'){
		    		this.myFacades = res.data;
		    		this.myFacades.forEach(element => {
						if(element.facade_id == _this.nowSelect){
							_this.$set(element,'active',true)
						}else{
							_this.$set(element,'active',false)
						}
					});
		    	}
		    	else{
		    		mui.toast(res.description,{ duration:'long'});	
		    	}
	  		}) 
      	},
        methods:{
        	goSiteList(){
        		this.$router.push({path: '/siteList'});
        	},
			isHasClass(myFacade){
				if(myFacade.facade_id == this.nowSelect){
					return 'mui-table-view-cell myFacade mui-selected';
				}else{
					return 'mui-table-view-cell myFacade';
				}
			},
			changeSel(ff){
				var _this = this;
				this.myFacades.forEach(element => {
					if(element.facade_id == ff.facade_id){
						_this.$set(element,'active',true)
					}else{
						_this.$set(element,'active',false)
					}
				});
			},
			selectFacade(){
				//确定选择区域后的实现效果。
				var _this = this;
				this.myFacades.forEach(element => {
					if(element.active){
						//确定保存
						sessionStorage.setItem("facade",JSON.stringify({
							id:element.facade_id,
							name:element.facade_name,
							money:element.balance,
							is_online_pay:element.is_online_pay
						}))
						_this.$router.push({path: '/home'});
					}
				});
			}
        }
    }
</script>
<style>
     @import '../common/css/public.css';
</style>


// WEBPACK FOOTER //
// src/pages/facadeList.vue